import React from 'react';

import {OEVersion} from '../../../react-oe/oe-version';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';
import {OEXRayTargetType, OEXRayTargetsSelector, OEXRayFeatureAccessSelector, OEXRayStartSelectionDataSelector} from './oe-xray-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';

export default class OEXRayStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = this.determineState();
    }

    determineState(props)   {
        props = props || this.props;

        let startSelectionData = OEXRayStartSelectionDataSelector.get(props.version);

        let modules = startSelectionData.chooseModules();

        //
        let targetTypeEntries = [
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEXRayTargetType.xRayArm, stringId: 'start_view_title_x_ray_arm', icon: OEIconCodes.xRay.xRayArmTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEXRayTargetType.xRayLeg, stringId: 'start_view_title_x_ray_leg', icon: OEIconCodes.xRay.xRayLegTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEXRayTargetType.xRayTrunk, stringId: 'start_view_title_x_ray_trunk', icon: OEIconCodes.xRay.xRayTrunkTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEXRayTargetType.anatomy, stringId: 'start_view_title_anatomy', icon: OEIconCodes.xRay.anatomyTarget},
        ].filter(entry => modules.findIndex(module => module.id === entry.targetType) >= 0 && (props.version !== OEVersion.xRayMin || entry.targetType !== OEXRayTargetType.anatomy));

        //
        let entries = [
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: true}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                ...targetTypeEntries,
                {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/}
            ]},
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: false}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '4.625em' /*74*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEFNWelcomeEntryTypes.licensing},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.25em' /*36*/},
                //{type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection_no_license', html: true},
                //{type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                //{type: OEProtoStartViewEntryTypes.demo, targetType: OEXRayTargetType.anatomy, stringId: 'start_view_title_anatomy', icon: OEIconCodes.xRay.anatomyTarget},
                //{type: OEFNWelcomeEntryTypes.spacer, height: '2.125em' /*34*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/}
            ]},
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/}
        ];

        //
        return {
            entries:                    entries,
            versionTargets:             OEXRayTargetsSelector.get(props.version),
            featureAccess:              OEXRayFeatureAccessSelector.get(props.version),
            startSelectionData:         startSelectionData,
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.version !== this.props.version)    {
            this.setState(this.determineState(nextProps));
        }
    }

    render()    {
        return (
            <OEProtoStartView
                {...this.props}
                {...this.state}
            />
        );
    }
}